import { useDisclosure } from "@mantine/hooks"
import { useState } from "react"
import { RuleGroupType } from "react-querybuilder"

import { QueryBuilder } from "@costory/front/components/QueryBuilder"
import { QueryBuilderPickerType } from "@costory/front/components/queryBuilder/QueryBuilderPicker"

type Props = {
  value?: RuleGroupType
  defaultValue?: RuleGroupType
  onChange: (query: RuleGroupType | null) => void
  queryError?: boolean
  resetKey?: string
}

export const QueryBuilderWrapper = ({
  value,
  defaultValue,
  onChange,
  queryError = false,
  resetKey,
}: Props) => {
  const [queryBuilderType, setQueryBuilderType] =
    useState<QueryBuilderPickerType>("regular")
  const [popoverOpened, { open: openPopover, close: closePopover }] =
    useDisclosure(true)

  return (
    <QueryBuilder
      key={resetKey}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      queryError={queryError}
      queryBuilderType={queryBuilderType}
      setQueryBuilderType={setQueryBuilderType}
      popoverOpened={popoverOpened}
      onPopoverOpen={openPopover}
      onPopoverClose={closePopover}
    />
  )
}
